import Moment from "moment";

export function formatDataToTableColumnValues (tablData, orderColumns: string[] | never[] = []) {
    if (orderColumns.length > 0) {
        return orderColumns.map(el => {
            return columnRenderer(el)
        }) as unknown as never[]
    } else if (tablData.length > 0) {
        return Object.keys(tablData[0]|| {}).map(el => {
            return columnRenderer(el)
        }) as unknown as never[]
    }
return []
}

function columnRenderer(el) {
    if (el === 'batches') {
        return {
            field: el,
            headerName: humanize(el),
            filter: true,
            tooltipValueGetter: params => {
                // put the value in bold
                return (params?.value||[]).map((itm: Record<string,string>) => itm.batch).join(',')
            },
            cellRenderer: params => {
                // put the value in bold
                return params.value.map((itm: Record<string,string>) => itm.batch).join(',')
            }
        }
    }

    if (el === 'userRoles') {
        return {
            field: el,
            headerName: humanize(el),
            filter: true,
            tooltipValueGetter: params => {
                // put the value in bold
                return (params?.value||[]).map((itm: Record<string,string>) => itm.roleName).join(',')
            },
            cellRenderer: params => {
                // put the value in bold
                return params.value.map((itm: Record<string,string>) => itm.roleName).join(',')
            }
        }
    }

    if (el === 'topics') {
        return {
            field: el,
            headerName: humanize(el),
            filter: true,
            tooltipValueGetter: params => {
                // put the value in bold
                return (params?.value||[]).map((itm: Record<string,string>) => itm.topic).join(',')
            },
            cellRenderer: params => {
                // put the value in bold
                return params.value.map((itm: Record<string,string>) => itm.topic).join(',')
            }
        }
    }
    if (el === 'createdDate' || el === 'updatedDate') {
        return {
            field: el,
            headerName: humanize(el),
            filter: true,
            tooltipValueGetter: params => {
                // put the value in bold
                return Moment(params?.value).format('DD-MM-YYYY hh:mm A')

            },
            cellRenderer: params => {
                // put the value in bold
                return Moment(params.value).format('DD-MM-YYYY hh:mm A')
            }
        }
    }
    return {
        field: el,
        headerName: humanize(el),
        tooltipField: el,
        filter: true
    }
}

export function humanize(str) {
    return str
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/^[a-z]/, function(m) { return m.toUpperCase(); });
  }

export const firstColumn = {
    headerName: '',
    field: '',
    checkboxSelection: true,
    width: 40,
    headerCheckboxSelection: true,
  }